import { useState, useEffect, useRef, useCallback } from 'react'
import * as api from '../../../lib/api'

// ============================================
// IvideonPreview — карточка камеры (SNAPSHOT mode)
// Вместо HLS стрима показываем обновляемый JPEG-снимок.
// HLS загружается ТОЛЬКО при открытии FullscreenPlayer.
// Это снижает нагрузку на Ivideon с 4-5 HLS-сессий до ~24 snapshot-запросов/мин.
// ============================================
export default function IvideonPreview({ camera, hovered = false, onOpenFullscreen }) {
  const [snapshotUrl, setSnapshotUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const mountedRef = useRef(true)
  const intervalRef = useRef(null)
  const fullId = `${camera.ivideon_server_id}:${camera.ivideon_camera_id || '0'}`

  const SNAPSHOT_INTERVAL = 10000 // 10 секунд

  const loadSnapshot = useCallback(async () => {
    try {
      const result = await api.getIvideonSnapshot(fullId)
      if (mountedRef.current && result.url) {
        setSnapshotUrl(result.url + '&_t=' + Date.now())
        setLoading(false)
        setError(false)
      }
    } catch (err) {
      console.warn('[IvideonPreview] Snapshot error:', err)
      // Не показываем ошибку если уже есть снапшот (просто пропускаем обновление)
      if (!snapshotUrl && mountedRef.current) {
        setLoading(false)
        setError(true)
      }
    }
  }, [fullId])

  useEffect(() => {
    mountedRef.current = true
    // Первая загрузка снапшота
    loadSnapshot()
    // Автообновление каждые 10 секунд
    intervalRef.current = setInterval(() => {
      if (mountedRef.current) loadSnapshot()
    }, SNAPSHOT_INTERVAL)

    return () => {
      mountedRef.current = false
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [])

  return (
    <div className="camera-preview-container">
      {loading && !error && (
        <div className="camera-loader-overlay">
          <div className="spinner" />
          <span>Загрузка снимка...</span>
        </div>
      )}
      {error && (
        <div className="camera-preview-error">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span>Камера временно недоступна</span>
        </div>
      )}
      {snapshotUrl && (
        <div className="snapshot-fallback-container visible">
          <img
            src={snapshotUrl}
            alt={camera.name}
            className="snapshot-fallback-img"
          />
        </div>
      )}
      {/* Бейдж LIVE (снимки обновляются) */}
      {snapshotUrl && !loading && !error && (
        <div className="camera-preview-live-badge">● LIVE</div>
      )}
    </div>
  )
}
